function initAssignment() {
  const dialog = document.querySelector<HTMLDialogElement>('[data-assignment-dialog]');
  if (dialog) {
    if (dialog.open) dialog.close();
    dialog.showModal();
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      window.location.assign(dialog.dataset.closeUrl!);
    });
  }
  document.querySelectorAll<HTMLFormElement>('[data-assignment-confirm]').forEach(form => {
    form.addEventListener('submit', event => {
      if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      form.setAttribute('aria-busy', 'true');
      form.querySelector<HTMLButtonElement>('button[type="submit"]')!.disabled = true;
    });
  });
}
document.addEventListener('DOMContentLoaded', initAssignment);
window.addEventListener('pageshow', () => {
  document.querySelectorAll<HTMLFormElement>('[data-assignment-confirm][aria-busy]').forEach(form => {
    form.removeAttribute('aria-busy');
    form.querySelector<HTMLButtonElement>('button[type="submit"]')!.disabled = false;
  });
});
